module.exports = __webpack_public_path__ + "img/b2.e71ee27c.jpg";